"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _dealerDetails = _interopRequireDefault(require("../../styles/dealerDetails.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
/* The measurement labels (mi vs km) is handled by graphql */

var DealerDistance = function DealerDistance(_ref) {
  var distance = _ref.distance,
    distanceLabel = _ref.distanceLabel,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _dealerDetails["default"].dealerDistance
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.smallType
  }, distance, " ", distanceLabel));
};
var mapStateToProps = function mapStateToProps(state) {
  var distanceLabel = state.Config.distance !== undefined && state.Config.distance !== null ? state.Config.distance.shortName : '';
  return {
    distanceLabel: distanceLabel
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(DealerDistance);
exports["default"] = _default;